import React from 'react';
import { STUDIO_COPY } from '../config';
import { legalPageUrl } from '../studioLinks';
import StudioHostLink from './StudioHostLink';

const StudioFooter: React.FC = () => {
  const year = new Date().getFullYear();
  const termsUrl = legalPageUrl('terms');
  const privacyUrl = legalPageUrl('privacy');

  return (
    <footer className="studio-footer" data-testid="studio-footer">
      <span>{STUDIO_COPY.footerBrand}</span>
      <span aria-hidden className="studio-footer-dot">
        ·
      </span>
      <StudioHostLink
        href={termsUrl}
        className="studio-footer-link"
        testId="studio-footer-terms"
      >
        Terms
      </StudioHostLink>
      <span aria-hidden className="studio-footer-dot">
        ·
      </span>
      <StudioHostLink
        href={privacyUrl}
        className="studio-footer-link"
        testId="studio-footer-privacy"
      >
        Privacy
      </StudioHostLink>
      <span aria-hidden className="studio-footer-dot">
        ·
      </span>
      <span>
        © {year} Scoutlytics
      </span>
    </footer>
  );
};

export default StudioFooter;
